<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
                <li>{{ pageTitle.subTitle }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div
                    class="services-details-desc pb-70"
                    *ngFor="let DetailsDesc of servicesDetailsDesc"
                >
                    <span class="sub-title">{{ DetailsDesc.subTitle }}</span>
                    <h3>{{ DetailsDesc.title1 }}</h3>
                    <div class="row">
                        <div
                            *ngIf="this.pageData === 'kepler'"
                            class="col-lg-6 col-md-6"
                        >
                            <div class="image">
                                <img [src]="DetailsDesc.img1" alt="image" />
                            </div>
                        </div>
                        <div
                            *ngIf="this.pageData === 'kepler'"
                            class="col-lg-6 col-md-6"
                        >
                            <p [innerHTML]="DetailsDesc.paragraphText1"></p>
                        </div>
                    </div>
                    <p
                        *ngIf="this.pageData != 'kepler'"
                        [innerHTML]="DetailsDesc.paragraphText1"
                    ></p>

                    <!-- <div class="row align-items-center">
                        <div class="col-lg-6 col-md-6">
                            <div class="image">
                                <img [src]="DetailsDesc.img1" alt="image">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6">
                            <div class="content">
                                <h3>{{DetailsDesc.title2}}</h3>

                                <ul>
                                    <li *ngFor="let ImportantFacts of servicesDetailsDescImportantFacts;">{{ImportantFacts.title}}</li>
                                </ul>
                            </div>
                        </div>
                    </div> -->

                    <p [innerHTML]="DetailsDesc.paragraphText2"></p>

                    <!-- <h3>{{DetailsDesc.title3}}</h3>

                    <div class="row">
                        <div class="col-lg-4 col-sm-6 col-md-6" *ngFor="let Application of servicesDetailsDescApplication;">
                            <div class="single-industries-serve-box">
                                <div class="icon">
                                    <i class="{{Application.icon}}"></i>
                                </div>
                                
                                {{Application.title}}
                            </div>
                        </div>
                    </div> -->

                    <!-- <h3>{{DetailsDesc.title4}}</h3>

                    <ul class="technologies-features">
                        <li *ngFor="let TechnologiesFeatures of servicesDetailsDescTechnologiesFeatures;"><span>{{TechnologiesFeatures.title}}</span></li>
                    </ul>

                    <div class="charts-image">
                        <img [src]="DetailsDesc.img2" alt="image">
                    </div> -->
                </div>
                <div
                    class="services-details-image"
                    *ngFor="let DetailsImage of servicesDetailsImage"
                >
                    <img [src]="DetailsImage.img" alt="image" />
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-info">
                    <!-- <ul class="services-list">
                        <li *ngFor="let ServicesList of sidebarServicesList;"><a routerLink="/{{ServicesList.link}}">{{ServicesList.title}}</a></li>
                    </ul> -->

                    <!-- <div class="download-file">
                        <h3>Brochures</h3>

                        <ul>
                            <li *ngFor="let DownloadFile of sidebarDownloadFile;"><a routerLink="/{{DownloadFile.link}}">{{DownloadFile.title}} <i class='{{DownloadFile.icon}}'></i></a></li>
                        </ul>
                    </div> -->

                    <div class="services-contact-info">
                        <h3>Contact Info</h3>

                        <ul>
                            <li *ngFor="let ContactInfo of sidebarContactInfo">
                                <div class="icon">
                                    <img [src]="ContactInfo.icon" />
                                </div>
                                <span>{{ ContactInfo.title }}:</span>
                                <p [innerHTML]="ContactInfo.subTitle"></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-related-services></app-related-services>
